module.exports=function(n){var r=String(n).split(".")[0];return 0==r||1==r?"one":"other"}